module.exports = __webpack_public_path__ + "static/img/content_bg_ar.62812695.png";